import { useEffect, useState } from "react";
import { http, money, defaultStatuses, notify, maskMobile } from "../api";
import { Status, Loading } from "./common";

export default function Applications({ user, onSelect }) {
  const [items, setItems] = useState([]);
  const [banks, setBanks] = useState([]);
  const [status, setStatus] = useState("");
  const [bank, setBank] = useState("");
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    http.get(`/applications?status=${status}&bank_name=${encodeURIComponent(bank)}`)
      .then((r) => setItems(r.data))
      .catch((err) => notify.error(err, "Could not load applications"))
      .finally(() => setLoading(false));
  };

  useEffect(load, [status, bank]);
  useEffect(() => { http.get("/banks").then((r) => setBanks(r.data)).catch(() => {}); }, []);

  return (
    <>
      <div className="page-intro">
        <div>
          <p className="eyebrow">PROCESSING / CASEWORK</p>
          <h1>Applications</h1>
          <p className="muted">Track every partner-bank submission through to outcome.</p>
        </div>
      </div>

      <div className="toolbar">
        <select data-testid="apps-status-filter" value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">All application statuses</option>
          {defaultStatuses.map((x) => <option key={x}>{x}</option>)}
        </select>
        <select data-testid="apps-bank-filter" value={bank} onChange={(e) => setBank(e.target.value)}>
          <option value="">All partner banks</option>
          {banks.map((b) => <option key={b.bank_id} value={b.name}>{b.name}</option>)}
        </select>
        <button className="outline-button" onClick={() => { setStatus(""); setBank(""); }}>Clear</button>
        <span className="record-count">{loading ? "Loading…" : `${items.length} applications`}</span>
      </div>

      {loading && !items.length ? (
        <Loading>Loading applications…</Loading>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Application</th>
                <th>Customer</th>
                <th>Partner / product</th>
                <th>Requested</th>
                <th>Payout</th>
                <th>Status</th>
                <th>Last updated</th>
              </tr>
            </thead>
            <tbody>
              {items.map((x) => (
                <tr
                  data-testid={`application-row-${x.application_id}`}
                  key={x.application_id}
                  className="clickable-row"
                  onClick={() => onSelect?.(x.lead_id)}
                >
                  <td>
                    <strong className="mono">{x.application_id}</strong>
                    <span className="cell-sub">Lead {x.lead_id}</span>
                  </td>
                  <td data-label="Customer">
                    <strong>{x.customer_name}</strong>
                    <span className="cell-sub">{maskMobile(x.mobile)}</span>
                  </td>
                  <td data-label="Partner">
                    {x.bank_name || x.bank_id}
                    <span className="cell-sub">{x.product_name || x.product_id}</span>
                  </td>
                  <td data-label="Requested">{money(x.requested_amount)}</td>
                  <td data-label="Payout">
                    <strong>{money(x.commission_amount)}</strong>
                    <span className="cell-sub">
                      {x.commission_percent ? `${x.commission_percent}% · ` : ""}
                      {x.commission_status || "pending"}
                    </span>
                  </td>
                  <td data-label="Status"><Status value={x.status} /></td>
                  <td data-label="Updated" className="muted">{x.updated_at?.slice(0, 10)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!items.length && <div className="empty">No applications in this view.</div>}
        </div>
      )}
    </>
  );
}
